import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment-timezone';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import service from '../../services';
import commonImage from '../../commonImage';
import { QUICK_LINK_NAVIGATION_TYPE_KEY } from '../../cosntants';
import TextField from '../TextField';
import AppRoutePicker from './AppRoutePicker';
import UploadForm from '../UploadForm';
import Loader from '../loader';
import PopUpCustomAll from '../fpg/create/popUpCustomAll';
import DeletefileIcon from '../../icons/DeletefileIcon';
import EditIcon from '../../icons/EditIcon';
import FpgPlusIcon from '../../icons/fpgplusicon';
import FpgMinusIcon from '../../icons/fpgminusicon';
import DraggerIcon from '../../icons/draggericon';
import delet from '../../assets/images/delet.svg';

const DisplayScreeningDate = (dateNew, locationType, formate) => {
  const formateCheck = formate || 'MMM. D, h:mm A';
  if (locationType === '1') {
    return moment(new Date(dateNew)).tz('America/Denver').format(formateCheck);
  }
  return moment(new Date(dateNew)).local().format(formateCheck);
};

class HomePageQuickLinksList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      quickLinksList: [],
      errorMsg: false,
      errorMsgShow: '',
      // Delete confirmation
      deletePopup: false,
      deleteId: null,
      // Popup state (shared for add and edit)
      showPopup: false,
      popupMode: 'add',
      popupItem: null,
      popupInitialData: null,
      popupIsEdited: false,
      popupImagePreloader: false,
      lastUpdated: null,
      lastUpdatedBy: '',
    };

    this.popupValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        urlValidation: {
          message: 'Please enter a valid URL',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
            ) && params.indexOf(val) === -1,
          required: false,
        },
      },
    });

    this.apiserve = new service();
  }

  mapDocToLocal = (doc) => {
    const typeMap = {
      1: QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL,
      2: QUICK_LINK_NAVIGATION_TYPE_KEY.APP_PAGE,
    };
    return {
      _id: doc._id,
      adTitle: doc.adTitle || '',
      adImage: doc.adImage || '',
      adStartDate: doc.adStartDate ? new Date(doc.adStartDate) : null,
      adEndDate: doc.adEndDate ? new Date(doc.adEndDate) : null,
      adNavigationType: {
        type: typeMap[doc.adNavigationType?.type] || QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL,
        value: doc.adNavigationType?.value || '',
      },
      adNavigationParams: (doc.adNavigationParams || []).map(p => ({ key: p.key || '', value: p.value || '' })),
      isActive: doc.isActive !== false,
    };
  };

  markPopupEdited = () => {
    if (this.state.popupMode === 'edit' && this.state.popupInitialData) {
      const isDirty = !isEqual(this.state.popupInitialData, this.state.popupItem);
      if (this.state.popupIsEdited !== isDirty) {
        this.setState({ popupIsEdited: isDirty });
      }
    }
  };

  componentDidMount = () => {
    this.setupSocketEvents();
    this.getData();
    this.setState({ loaderFlag: true });
  };

  componentWillUnmount = () => {
    if (this.sub) this.sub.unsubscribe();
  };

  setupSocketEvents = () => {
    this.sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case 'homePageApp|homePageQuickLink|getAllList':
          if (!response.error && response.data?.data?.docs) {
            const docs = response.data.data.docs;
            const quickLinksList = docs.map(this.mapDocToLocal);
            // Prefer the most recently updated doc that has an updatedBy, fall back to any latest
            const withUser = docs.filter(d => d.updatedBy);
            const latestRecord = withUser.length
              ? withUser.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0]
              : [...docs].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
            const lastUpdated = latestRecord?.updatedAt || null;
            const lastUpdatedBy = latestRecord?.updatedBy
              ? `${latestRecord.updatedBy.fname || ''} ${latestRecord.updatedBy.lname || ''}`.trim()
              : '';
            this.setState({ quickLinksList, loaderFlag: false, lastUpdated, lastUpdatedBy });
          } else {
            this.setState({ loaderFlag: false });
          }
          break;

        case 'homePageApp|homePageQuickLink|create':
        case 'homePageApp|homePageQuickLink|edit':
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error || 'An error occurred' });
          } else {
            this.setState({ loaderFlag: false });
            this.apiserve.success(
              response.event === 'homePageApp|homePageQuickLink|create'
                ? 'Quick link created successfully.'
                : 'Quick link updated successfully.'
            );
            this.getData();
          }
          break;

        case 'homePageApp|homePageQuickLink|remove':
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error || 'Failed to remove quick link' });
          } else {
            this.setState({ loaderFlag: false });
            this.apiserve.success('Quick link removed successfully.');
            this.getData();
          }
          break;

        case 'homePageApp|homePageQuickLink|changeOrder':
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error || 'Failed to update order' });
            this.getData();
          } else {
            this.setState({ loaderFlag: false });
          }
          break;

        default:
          break;
      }
    });
  };

  getData = () => {
    this.apiserve.sendevent('homePageApp|homePageQuickLink|getAllList', { limit: 100, page: 1 });
  };

  validateModel = () => {
    this.setState({ errorMsg: false });
  };

  removeItem = (id) => {
    this.setState({ deletePopup: true, deleteId: id });
  };

  confirmRemove = () => {
    this.setState({ loaderFlag: true, deletePopup: false });
    this.apiserve.sendevent('homePageApp|homePageQuickLink|remove', { homePageQuickLinkId: this.state.deleteId });
  };

  // --- Popup methods ---

  openAddPopup = () => {
    this.popupValidator.hideMessages();
    this.setState({
      showPopup: true,
      popupMode: 'add',
      popupInitialData: null,
      popupIsEdited: false,
      popupItem: {
        adTitle: '',
        adImage: '',
        adStartDate: null,
        adEndDate: null,
        adNavigationType: { type: QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL, value: '' },
        adNavigationParams: [{ key: '', value: '' }],
        isActive: true,
      },
      popupImagePreloader: false,
    });
  };

  openEditPopup = (item) => {
    this.popupValidator.hideMessages();
    const converted = {
      ...item,
      adStartDate: this.getMtDateForPicker(item.adStartDate),
      adEndDate: this.getMtDateForPicker(item.adEndDate),
    };
    const snapshot = cloneDeep(converted);
    this.setState({
      showPopup: true,
      popupMode: 'edit',
      popupItem: cloneDeep(converted),
      popupInitialData: snapshot,
      popupIsEdited: false,
      popupImagePreloader: false,
    });
  };

  closePopup = () => {
    this.popupValidator.hideMessages();
    this.setState({ showPopup: false, popupItem: null, popupInitialData: null, popupIsEdited: false });
  };

  handleFieldChange = (field, value) => {
    this.setState(prev => ({
      popupItem: { ...prev.popupItem, [field]: value }
    }), () => this.markPopupEdited());
  };

  handleNavTypeChange = (value) => {
    this.popupValidator.hideMessages();
    this.setState(prev => ({
      popupItem: { ...prev.popupItem, adNavigationType: { type: value, value: '' } }
    }), () => this.markPopupEdited());
  };

  handleNavValueChange = (val) => {
    this.setState(prev => ({
      popupItem: { ...prev.popupItem, adNavigationType: { ...prev.popupItem.adNavigationType, value: val } }
    }), () => this.markPopupEdited());
  };

  handleParamChange = (paramIndex, field, value) => {
    this.setState(prev => {
      const newParams = prev.popupItem.adNavigationParams.map((p, idx) =>
        idx === paramIndex ? { ...p, [field]: value } : p
      );
      return { popupItem: { ...prev.popupItem, adNavigationParams: newParams } };
    }, () => this.markPopupEdited());
  };

  addParam = () => {
    if (this.state.popupItem.adNavigationParams.length >= 10) return;
    this.setState(prev => ({
      popupItem: {
        ...prev.popupItem,
        adNavigationParams: [...prev.popupItem.adNavigationParams, { key: '', value: '' }],
      }
    }), () => this.markPopupEdited());
  };

  removeParam = (paramIndex) => {
    this.setState(prev => ({
      popupItem: {
        ...prev.popupItem,
        adNavigationParams: prev.popupItem.adNavigationParams.filter((_, idx) => idx !== paramIndex),
      }
    }), () => this.markPopupEdited());
  };

  onChangeFile = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize >= 2048) {
        this.setState({ errorMsg: true, errorMsgShow: 'Please upload a file smaller than 2 MB' });
        return;
      }
      if (file.type === 'image/svg+xml') {
        // SVG — vector format, no aspect ratio check needed
        this.imageUpload(file, event.target.result);
      } else if (file.type === 'image/png') {
        this.imageUpload(file, event.target.result);
      } else {
        this.setState({ errorMsg: true, errorMsgShow: 'Please upload a SVG or PNG file' });
      }
    };
  };

  imageUpload = (file, img) => {
    this.setState({ popupImagePreloader: true });
    const fileSet = commonImage(file, false, this.apiserve.formbucketAds, img);
    fileSet.then((value) => {
      this.setState(prev => ({
        popupItem: { ...prev.popupItem, adImage: value || '' },
        popupImagePreloader: false,
      }), () => this.markPopupEdited());
    });
  };

  getMtDateForPicker = (date) => {
    if (!date) return null;
    const ABBR = moment.tz('America/Denver').format('z');
    const offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    return moment(date).subtract(offDifference, 'minutes').toDate();
  };

  getMtTime = (date) => {
    if (!date) return null;
    const ABBR = moment.tz('America/Denver').format('z');
    const offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    return moment(date).add(offDifference, 'minutes').toISOString();
  };

  savePopup = (e) => {
    e.preventDefault();
    if (!this.popupValidator.allValid()) {
      this.popupValidator.showMessages();
      this.forceUpdate();
      return;
    }
    const item = this.state.popupItem;
    if (item.adEndDate && item.adStartDate && item.adEndDate <= item.adStartDate) {
      this.setState({ errorMsg: true, errorMsgShow: 'End date must be after start date' });
      return;
    }
    this.setState({ loaderFlag: true });
    const payload = {
      adTitle: item.adTitle,
      adImage: item.adImage,
      adStartDate: item.adStartDate ? this.getMtTime(item.adStartDate) : '',
      adEndDate: item.adEndDate ? this.getMtTime(item.adEndDate) : '',
      adNavigationType: { type: item.adNavigationType.type, value: item.adNavigationType.value },
      adNavigationParams: item.adNavigationParams,
      isActive: item.isActive,
    };
    if (this.state.popupMode === 'edit') {
      this.apiserve.sendevent('homePageApp|homePageQuickLink|edit', { homePageQuickLinkId: item._id, ...payload });
    } else {
      this.apiserve.sendevent('homePageApp|homePageQuickLink|create', payload);
    }
    this.closePopup();
  };

  onDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) return;
    const reordered = Array.from(this.state.quickLinksList);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    const order = reordered.map((item, idx) => ({ homePageQuickLinkId: item._id, sortIndex: idx }));
    this.setState({ quickLinksList: reordered, loaderFlag: true });
    this.apiserve.sendevent('homePageApp|homePageQuickLink|changeOrder', { order });
  };

  render() {
    const { quickLinksList, lastUpdated, lastUpdatedBy, loaderFlag, showPopup, popupItem, popupMode, popupIsEdited, popupImagePreloader } = this.state;

    return (
      <div className="schedule_ads_tab_content app_quicklinks">

        {/* Last Updated meta bar */}
        {lastUpdated && (
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <p></p>
            <p className="update_date">
              Last Update: {DisplayScreeningDate(lastUpdated, '1', 'hh:mm A')} MT -{DisplayScreeningDate(lastUpdated, '1', 'MM/DD/YYYY')} Last Updated By: {lastUpdatedBy || ''}
            </p>
          </div>
        )}

        {/* Table */}
        <div className="category_add_edit">
          <div className="table_wrap product_list_tbl film_list_table striped_table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Ad Title</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Navigation Type</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="quick-links-list">
                  {(provided) => (
                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                      {quickLinksList.length === 0 ? (
                        <tr>
                          <td colSpan="8" style={{ textAlign: 'center', padding: '30px' }}>
                            No quick links added yet. Click <strong>+</strong> to add your first quick link.
                          </td>
                        </tr>
                      ) : (
                        quickLinksList.map((item, i) => (
                          <Draggable key={item._id} draggableId={item._id} index={i}>
                            {(drag, snapshot) => (
                              <tr
                                ref={drag.innerRef}
                                {...drag.draggableProps}
                                style={{
                                  ...drag.draggableProps.style,
                                  background: snapshot.isDragging ? '#f0f0f0' : '',
                                }}
                              >
                                <td {...drag.dragHandleProps} style={{ cursor: 'grab', width: '30px' }}>
                                  <DraggerIcon />
                                </td>
                                <td>{i + 1}</td>
                                <td>{item.adTitle || '—'}</td>
                                <td>
                                  {item.adStartDate
                                    ? DisplayScreeningDate(item.adStartDate, '1', 'MMM DD YYYY - h:mm A')
                                    : '—'}
                                </td>
                                <td>
                                  {item.adEndDate
                                    ? DisplayScreeningDate(item.adEndDate, '1', 'MMM DD YYYY - h:mm A')
                                    : '—'}
                                </td>
                                <td>
                                  {item.adNavigationType?.type === QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL
                                    ? 'External URL'
                                    : 'App Page'}
                                </td>
                                <td>{item.isActive ? 'Yes' : 'No'}</td>
                                <td>
                                  <div className="action_wrap d_flex d_flex_align_center">
                                    <span className="cat_edit pointer" onClick={() => this.openEditPopup(item)}>
                                      <EditIcon />
                                    </span>
                                    <span className="remove_cat pointer" onClick={() => this.removeItem(item._id)}>
                                      <img src={delet} alt="delete" />
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))
                      )}
                      {provided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </DragDropContext>
            </table>
          </div>
        </div>

        {/* Add / Edit Popup */}
        <div className={`user_popup ${showPopup ? 'active' : ''}`}>
          <span className="popup_overlay" onClick={this.closePopup}></span>
          <div className="cat_modal_inner sd_schedule_ad_modal">
            <p className="cat_title text_center">
              {popupMode === 'edit' ? 'Edit Quick Link' : 'Add Quick Link'}
            </p>
            {popupItem && (
              <form>
                <div className="sd_popup_layout">
                  {/* Left: image upload */}
                  <div className="sd_popup_img_col">
                    <div className="sd_popup_img_box loader-main">
                      {popupImagePreloader ? (
                        <Loader />
                      ) : (
                        <img
                          src={popupItem.adImage ? this.apiserve.imageUrl + popupItem.adImage : '/images/image-placeholder.png'}
                          onError={e => { e.target.src = '/images/image-placeholder.png'; }}
                          alt="Quick link preview"
                        />
                      )}
                      <UploadForm item={popupItem} handleImage={e => this.onChangeFile(e)} accept=".svg, .png" />
                      {popupItem.adImage && (
                        <span
                          className="remove_file pointer"
                          onClick={() => this.setState(prev => ({ popupItem: { ...prev.popupItem, adImage: '' } }))}
                        >
                          <DeletefileIcon />
                        </span>
                      )}
                    </div>
                    <span className="error_note">Max Size 2MB · SVG or PNG</span>
                    <span style={{ color: 'red' }}>
                      {this.popupValidator.message('Ad Image', popupItem.adImage, 'required')}
                    </span>
                  </div>

                  {/* Right: form fields */}
                  <div className="sd_popup_fields_col">
                    {/* Ad Title */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Link Title</label>
                        <div className="field_input relative">
                          <textarea
                            value={popupItem.adTitle}
                            onChange={e => this.handleFieldChange('adTitle', e.target.value)}
                            placeholder="Enter ad title"
                          />
                          <span style={{ color: 'red' }}>
                            {this.popupValidator.message('Ad Title', popupItem.adTitle, 'required')}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Start Date */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Start Date</label>
                        <div className="field_input relative">
                          <DatePicker
                            selected={popupItem.adStartDate}
                            onChange={date => this.handleFieldChange('adStartDate', date)}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeIntervals={15}
                            placeholderText="Select start date & time"
                            className="datepicker_input"
                            minDate={
                              popupItem.adStartDate && new Date(popupItem.adStartDate) < new Date()
                                ? new Date(popupItem.adStartDate)
                                : new Date()
                            }
                          />
                          <span style={{ color: 'red' }}>
                            {this.popupValidator.message('Start Date', popupItem.adStartDate, 'required')}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>End Date</label>
                        <div className="field_input relative">
                          <DatePicker
                            selected={popupItem.adEndDate}
                            onChange={date => this.handleFieldChange('adEndDate', date)}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeIntervals={15}
                            placeholderText="Select end date & time"
                            className="datepicker_input"
                            minDate={popupItem.adStartDate || new Date()}
                          />
                          <span style={{ color: 'red' }}>
                            {this.popupValidator.message('End Date', popupItem.adEndDate, 'required')}
                            {popupItem.adEndDate && popupItem.adStartDate && popupItem.adEndDate <= popupItem.adStartDate
                              ? <span> End date must be after start date</span>
                              : null}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Navigation Type */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Nav Type</label>
                        <div className="field_input relative">
                          <div className="sd_radio_row">
                            <label className="sd_radio_label">
                              <input
                                type="radio"
                                name="quickLinkNavType"
                                value={QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL}
                                checked={popupItem.adNavigationType.type === QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL}
                                onChange={() => this.handleNavTypeChange(QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL)}
                              />
                              External URL
                            </label>
                            <label className="sd_radio_label">
                              <input
                                type="radio"
                                name="quickLinkNavType"
                                value={QUICK_LINK_NAVIGATION_TYPE_KEY.APP_PAGE}
                                checked={popupItem.adNavigationType.type === QUICK_LINK_NAVIGATION_TYPE_KEY.APP_PAGE}
                                onChange={() => this.handleNavTypeChange(QUICK_LINK_NAVIGATION_TYPE_KEY.APP_PAGE)}
                              />
                              App Page
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Navigation Value */}
                    {popupItem.adNavigationType.type === QUICK_LINK_NAVIGATION_TYPE_KEY.EXTERNAL_URL ? (
                      <div className="field_row horizontal_field d_flex">
                        <TextField
                          name="quickLinkNavValue"
                          label="Nav URL"
                          type="text"
                          value={popupItem.adNavigationType.value}
                          onChange={e => this.handleNavValueChange(e.target.value)}
                          placeholder="https://..."
                          fpgerror={this.popupValidator.message('Navigation Value', popupItem.adNavigationType.value, 'required|urlValidation')}
                        />
                      </div>
                    ) : (
                      <div className="field_row horizontal_field d_flex">
                        <div className="field_row_inner">
                          <label>App Page</label>
                          <div className="field_input relative">
                            <AppRoutePicker
                              value={popupItem.adNavigationType.value}
                              onChange={val => this.handleNavValueChange(val)}
                              error={this.popupValidator.message('Navigation Value', popupItem.adNavigationType.value, 'required')}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Navigation Params */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Nav Params</label>
                        <div className="field_input relative">
                          <div className="sd_nav_params">
                            {popupItem.adNavigationParams.map((param, pIdx) => (
                              <div key={pIdx} className="sd_nav_param_row">
                                <input
                                  type="text"
                                  value={param.key}
                                  placeholder="key"
                                  onChange={e => this.handleParamChange(pIdx, 'key', e.target.value)}
                                  autoComplete="off"
                                />
                                <input
                                  type="text"
                                  value={param.value}
                                  placeholder="value"
                                  onChange={e => this.handleParamChange(pIdx, 'value', e.target.value)}
                                  autoComplete="off"
                                />
                                {popupItem.adNavigationParams.length < 10 && (
                                  <span className="pointer" onClick={this.addParam}>
                                    <FpgPlusIcon width="18" height="18" color="#000000" stroke="#ffffff" />
                                  </span>
                                )}
                                {popupItem.adNavigationParams.length > 1 && (
                                  <span className="pointer" onClick={() => this.removeParam(pIdx)}>
                                    <FpgMinusIcon width="18" height="18" color="#000000" stroke="#ffffff" />
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Active toggle */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label className="null">Active</label>
                        <label className="switch" style={{ minWidth: 'auto' }}>
                          <input
                            type="checkbox"
                            checked={popupItem.isActive}
                            onChange={() => this.handleFieldChange('isActive', !popupItem.isActive)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cat_btns text_center">
                  <button type="button" onClick={this.closePopup}>
                    CANCEL
                  </button>
                  <button
                    type="button"
                    disabled={popupMode === 'edit' && !popupIsEdited}
                    className={popupMode === 'edit' && !popupIsEdited ? '' : 'active'}
                    onClick={e => this.savePopup(e)}
                  >
                    SAVE
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

        {/* Error popup */}
        <div className={`user_popup ${this.state.errorMsg ? 'active' : ''}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>OK</button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete confirmation */}
        {this.state.deletePopup && (
          <PopUpCustomAll
            HeaderName="Remove Quick Link?"
            insideDetails="Are You Sure?"
            insideData="You want to remove this quick link"
            popupState={() => this.setState({ deletePopup: false, deleteId: null })}
            yesPopUp={this.confirmRemove}
          />
        )}

        {loaderFlag && <Loader />}
      </div>
    );
  }
}

export default HomePageQuickLinksList;